var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerSubstationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#000000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M633.85-61.54 487.69-207.69l42.16-43.39 74 73.24v-118.7H368.46q-30.31 0-51.31-21-20.99-21-20.99-51.31v-235.38H100v-60h196.16v-117.93l-74.01 73.24L180-752.31l146.15-146.15 146.16 146.15-42.16 43.39-74-73.24v413.31q0 4.62 3.85 8.47 3.85 3.84 8.46 3.84H860v60H663.84v118.7l74.01-73.24L780-207.69 633.85-61.54Zm-30-375v-155.38q0-4.62-3.85-8.46-3.85-3.85-8.46-3.85H436.15v-60h155.39q30.31 0 51.31 21 20.99 21 20.99 51.31v155.38h-59.99Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerSubstationIcon);
export default __webpack_public_path__ + "static/media/marker-substation-icon.e49168816378edc777bfbac8cf91be87.svg";
export { ForwardRef as ReactComponent };